<template>

	<!-- Comment List -->
	<div class="detail-comment">
		<!--			<div class="detail-comment" v-show="boardInfoVO.isComment && isLogin()">-->

		<div class="inner">

			<div class="comment-empty" v-if="commentList.length <= 0">
				<p>등록된 댓글이 없습니다.</p>
			</div>

			<ul class="comment-list" v-else-if="commentList.length > 0">

				<template v-for="(item, index) in commentList">
					<!--<li class="your | my">-->
					<li :class="{ 'my' : isMine(item.writerKeyDec), 'your' : !isMine(item.writerKeyDec)  }" >
						<div class="bubble">
							<div class="info">
								<strong class="name">{{ item.writerDec }}</strong>
								<span class="time">{{ item.createDate | datetimeFilter }}</span>
								<template v-if="isMine(item.writerKeyDec)">
									<a href="javascript:;" class="edit" @click="toggleUpdate(item)"><span class="blind">수정</span></a>
									<a href="javascript:;" class="delete" @click="doDelete(item.idx)"><span class="blind">삭제</span></a>
								</template>
							</div>
							<p class="comment" v-text="item.contentText" style="word-break: break-word;"></p>
						</div>

						<div :id="'comment-edit-' + item.idx" class="comment-input" style="display: none;">
							<form @submit.prevent="updateComment($event, item)">
								<div class="inp-box">
									<textarea class="auto_resize" name="" cols="30" :rows="item.contentText.split('\n').length" placeholder="댓글을 입력해 보세요" v-model="item.contentText" style="height: max-content"></textarea>
								</div>

								<div class="btn-box">
									<button class="btn-comment" type="submit">작성</button>
								</div>
							</form>
						</div>

					</li>
				</template>

			</ul>
			<div class="comment-input">
				<form @submit.prevent="setComment">
					<div class="inp-box">
						<textarea name="" id="commentWrite" cols="30" :rows="commentVO.contentText.split('\n').length" placeholder="댓글을 입력해 보세요" v-model="commentVO.contentText"></textarea>
					</div>
					<div class="btn-box">
						<button class="btn-comment" type="submit">작성</button>
					</div>
					{{ $('#commentWrite')._value }}
				</form>
			</div>
		</div>
	</div>

</template>

<script>
import Qs from "qs";

export default {
	name: "commentDefault",
	props: {
		bidx: Number,
	},
	data() {

		return {
			// idx: this.webUtils.getParameterInt("idx"),
			// idx: this.$route.query.idx,

			commentVO: new this.CommentVO( this.getSessionProc() ),
			commentList: [],
		}
	},
	created() {

		// alert( this.APIs.BASE_URL )

	},
	mounted() {

		if ( this.bidx > 0 ) {
			this.getCommentList();
		}

	},
	methods: {

		getCommentList() {

			this.$eventBus.$emit("startProgress", 2)
			this.axiosCaller.get( this,  this.APIs.BOARD_COMMENTS + "/" + this.bidx, {}, (res) => {
				var result = res.data;
				this.commentList = result.list

				this.$eventBus.$emit("doneProgress", 2)
			})

		},

		async setComment(e) {

			e.preventDefault()

			await this.requireLogin(this);

			if ( this.commentVO.contentText.trim().length <= 0 ) {
				this.swalUtils.gritter("댓글의 내용이 없습니다.", "댓글 내용을 입력해주세요.", "info", 1000)
				return
			}

			this.commentVO.bidx = this.bidx
			this.commentVO.writerKey = this.getSessionProc().coEmailId;
			this.commentVO.writer = this.getSessionProc().nickName;
			var temp = this.commentVO;

			this.$eventBus.$emit("startProgress")
			this.axiosCaller.post( this, this.APIs.BOARD_COMMENTS + "/" + this.bidx, temp, (res) => {

				this.$eventBus.$emit("doneProgress")
				const result = res.data;
				this.commentVO = new this.CommentVO( this.getSessionProc() );
				if ( result.status === "ok" ) {
					this.swalUtils.gritter("Success", "댓글이 저장 되었습니다", "success", 1000)
					this.getCommentList()
				}
			})

		},


		updateComment (e, _comment) {

			e.preventDefault()
			console.log(_comment)
			this.axiosCaller.patch( this, this.APIs.BOARD_COMMENTS + "/", {
				idx: _comment.idx,
				contentText: _comment.contentText,
			}, (res) => {
				const result = res.data
				this.toggleUpdate(_comment);
				this.getCommentList()
			})

		},



		toggleUpdate(_item ) {
			const display = document.querySelector('#comment-edit-' + _item.idx).style.display;
			if ( display === "none" ) {
				document.querySelector('#comment-edit-' + _item.idx).style.display = "block";
			} else {
				document.querySelector('#comment-edit-' + _item.idx).style.display = "none";
			}
		},



		doDelete ( _idx ) {

			this.swalUtils.fire("삭제하시겠습니까?", "회원님이 작성한 댓글이 삭제됩니다.", "error", true)
				.then((result) => {

					if ( result.isConfirmed ) {
						this.axiosCaller.delete( this, this.APIs.BOARD_COMMENTS + "/" + _idx, {}, (res) => {
							const result = res.data
							console.log(result)

							this.getCommentList()
						})
					}

				})

		},
	},
	watch: {

		'commentVO.contentText': async function (newVal) {

			if ( newVal.length > 0 && !this.isLogin() ) {

				console.log( "NO LOGIN" )
				await this.requireLogin(this);

				/*this.swalUtils.fire("로그인 후 사용하실 수 있습니다.", "확인 버튼을 누르시면 로그인 페이지로 이동합니다.", "info", null, true)
					.then((result) => {
						if ( result.isConfirmed ) {

							let temp = location.pathname + "?" + Qs.stringify( this.$route.query )
							location.href = "/member/login?referrer=" + encodeURIComponent(temp);
						}
					})*/
			}

		},

		/*'bidx': function (newVal) {

			if (newVal > 0) {
				this.getCommentList();
			}

		},*/
	}
}
</script>

<style scoped>

</style>
